/* Shto check the boxes (sections/shto-check-boxes.liquid). Each row is a <button aria-pressed>: a click (or Enter / Space)
   ticks or unticks it. The result box copies the live page: hidden with nothing ticked, the first result from 1 tick, the
   second from data-high-from ticks (3). Runs once per section, again when the theme editor reloads a section. */
(function () {
  function setup(root) {
    if (!root || root.dataset.shtoReady) return;
    root.dataset.shtoReady = '1';
    var rows = root.querySelectorAll('.shto-check-boxes__row');
    var result = root.querySelector('.shto-check-boxes__result');
    var low = root.querySelector('[data-shto-result="low"]');
    var high = root.querySelector('[data-shto-result="high"]');
    var highFrom = parseInt(root.getAttribute('data-high-from'), 10) || 3;

    function update() {
      var count = 0;
      for (var i = 0; i < rows.length; i++) if (rows[i].getAttribute('aria-pressed') === 'true') count++;
      if (result) result.hidden = count === 0;
      if (low) low.hidden = !(count > 0 && count < highFrom);
      if (high) high.hidden = count < highFrom;
    }

    for (var i = 0; i < rows.length; i++) {
      rows[i].addEventListener('click', function (e) {
        e.preventDefault();
        this.setAttribute('aria-pressed', this.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        update();
      });
    }
    update();
  }

  function setupAll() {
    var roots = document.querySelectorAll('[data-shto-section="shto-check-boxes"]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll);
  else setupAll();
  document.addEventListener('shopify:section:load', setupAll);
})();
